import React, { useEffect, useState } from "react";
import { IMainProps, Main } from "./components/main/index";
import ApplicationContext, { defaults } from "./context/ApplicationContext";
import { BrowserRouter } from "react-router";

<link rel="stylesheet" type="text/css" href="/dist/semantic.min.css"></link>;

function App() {
  const [date, setDate] = useState(new Date());

  useEffect(() => {
    window.setTimeout(() => {
      setDate(new Date());
    }, 1000);
  }, [date]);

  const props: IMainProps = {
    dateTime: date,
  };

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <ApplicationContext.Provider value={defaults}>
        <BrowserRouter>
          <Main {...props} />
        </BrowserRouter>
      </ApplicationContext.Provider>
    </div>
  );
}

export default App;
